module.exports = __webpack_public_path__ + "static/media/logo-text.e3f7cfdc.svg";